import { Breadcrumbs, Stack, Link, IconButton, Divider } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "../../assets/images/Icons/Home.svg";
import { MenuRounded } from "@mui/icons-material";
import { useContext } from "react";
import { AuthContext } from "../../store";

export const CustomBreadcrumbs = ({ breadcrumbs, showHomeIcon }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const { setAuth } = useContext(AuthContext);

  return (
    <>
      {showHomeIcon && (
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            py: "11px",
            px: "16px",
            height: "40px",
            backgroundColor: "background.paper",
          }}
        >
          <IconButton
            sx={{
              backgroundColor: "neutral.90",
              "&:hover": { backgroundColor: "neutral.90", opacity: 0.9 },
            }}
            size="small"
            onClick={() =>
              setAuth((draft) => {
                draft.isSidebarOpen = !draft.isSidebarOpen;
              })
            }
          >
            <MenuRounded sx={{ color: "neutral.20" }} fontSize="small" />
          </IconButton>

          <Divider
            orientation="vertical"
            variant="middle"
            sx={{ ml: "8px", mr: "6px" }}
          />

          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              color="inherit"
              onClick={(e) =>
                isStoreAdmin ? navigate("/store-admin") : navigate("/")
              }
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={HomeIcon} width={24} height={24} alt="logo" />
            </Link>

            {breadcrumbs}
          </Breadcrumbs>
        </Stack>
      )}
    </>
  );
};
